export interface FormOrVersionMatch {
  matchesForm: boolean;
  matchesVersion: boolean;
  count: number;
}

export const formatFormOrVersionMatchLabel = (
  match?: FormOrVersionMatch | null
): string | null => {
  if (!match) {
    return null;
  }

  if (match.matchesForm && match.matchesVersion) {
    return 'Form & version text found';
  }

  if (match.matchesForm) {
    return 'Form text found';
  }

  if (match.matchesVersion) {
    return 'Version text found';
  }

  return 'No form/version text match';
};

export const isFormOrVersionMatchMissing = (
  match?: FormOrVersionMatch | null
) => (match ? match.count === 0 : false);
